export default {
  customDashboard: {
    loading: 'Laden...',
    loadingData: 'Daten werden geladen...',
    selectedSensors: '{count} ausgewählte Sensoren',
    addNewChart: 'Neues Diagramm hinzufügen',
    chartTitle: 'Diagrammtitel',
    selectSensors: 'Sensoren auswählen',
    selectSensorValidation: 'Wählen Sie mindestens einen Sensor aus',
    chartType: 'Diagrammtyp',
    selectChartType: 'Wählen Sie einen Diagrammtyp',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    invalidDateRange: 'Ungültiger Datumsbereich',
    sensorColors: 'Sensorfarben',
    others: 'andere',
    buttons: {
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      update: 'Aktualisieren'
    },
    editChart: 'Diagramm bearbeiten',
    buttonColors: {
      green: '{sensorName} - Grün',
      yellow: '{sensorName} - Gelb',
      red: '{sensorName} - Rot'
    },
    selectDateRange: 'Datumsbereich auswählen',
    quickFilters: 'Schnellfilter',
    weeklyConsumption: 'Wöchentlicher Verbrauch',
    dataManager: 'Datenmanager',
    lastRefilling: 'Letzte Auffüllung',
    dispenserLevel: 'Spenderfüllstand',
    time: 'Zeit',
    levelStatus: 'Füllstandstatus',
    fullEmptyDispenser: 'Voller/Leerer Spender',
    emptyHours: 'Leere Stunden',
    consumptions: 'Verbrauch',
    downloadChartData: 'Diagrammdaten herunterladen',
    downloadAllData: 'Alle Daten herunterladen',
    addNewWidget: 'Neues Widget hinzufügen',
    widgetType: 'Widget-Typ',
    chartTemplate: 'Diagrammvorlage',
    comparisonLevel: 'Vergleichsebene',
    entitiesToCompare: 'Zu vergleichende Entitäten',
    period: 'Zeitraum',
    widgetTitle: 'Widget-Titel',
    size: 'Größe',
    filters: {
      title: 'Filter',
      clients: 'Kunden',
      buildings: 'Gebäude',
      floors: 'Etagen',
      areas: 'Bereiche',
      dispenserType: 'Spendertyp',
      productType: 'Produkttyp',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen'
    },
    sizes: {
      small: 'Klein',
      medium: 'Mittel',
      large: 'Groß'
    },
    kpiType: 'KPI-Typ',
    dataLevel: 'Datenebene',
    articleType: 'Artikeltyp',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    kpiTypes: {
      totalConsumption: {
        title: 'Gesamter Papierverbrauch',
        description: 'Gesamtes Papier im ausgewählten Zeitraum verbraucht'
      },
      averageDaily: {
        title: 'Durchschnittlicher Tagesverbrauch',
        description: 'Durchschnittlicher Papierverbrauch pro Tag'
      },
      mostUsedArticle: {
        title: 'Meistverwendeter Artikel',
        description: 'Meistverwendeter Papiertyp nach Prozentsatz'
      },
      inactiveZones: {
        title: 'Inaktive Zonen',
        description: 'Anzahl der Bereiche ohne Aktivität im ausgewählten Zeitraum'
      },
      estimatedCost: {
        title: 'Geschätzte Papierkosten',
        description: 'Geschätzte Kosten für Papier im ausgewählten Zeitraum'
      },
      peakUsageDay: {
        title: 'Tag mit Spitzenverbrauch',
        description: 'Der Tag mit dem höchsten Verbrauch im ausgewählten Zeitraum'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Papierverbrauch',
        description: 'Gesamten Papierverbrauch vergleichen'
      },
      usageFrequency: {
        title: 'Nutzungshäufigkeit',
        description: 'Vergleichen Sie, wie oft Bereiche genutzt werden'
      },
      paperCost: {
        title: 'Papierkosten',
        description: 'Geschätzte Kosten des Papierverbrauchs vergleichen'
      },
      alertEvents: {
        title: 'Alarmereignisse',
        description: 'Vergleichen Sie, wie viele Alarmereignisse aufgetreten sind'
      },
      consumptionVsFrequency: {
        title: 'Verbrauch vs. Häufigkeit',
        description: 'Vergleichen Sie die tägliche Nutzungshäufigkeit mit dem Papierverbrauch für einen ausgewählten Bereich'
      },
      sensorComparison: {
        title: 'Sensorvergleich',
        description: 'Historische Daten zwischen ausgewählten Sensoren vergleichen'
      },
      consumptionVsBathroom: {
        title: 'Verbrauch vs. Toilettennutzung',
        description: 'Korrelation zwischen Papierverbrauch und Toilettennutzungshäufigkeit'
      }
    },
    sensorCategories: {
      dispenser: 'Spender',
      doors: 'Türen'
    },
    sensorComparison: {
      title: 'Sensorvergleich',
      selectSensors: 'Sensoren zum Vergleichen auswählen',
      selectCategory: 'Kategorie auswählen',
      noSensorsSelected: 'Wählen Sie mindestens einen Sensor zum Vergleichen aus',
      loading: 'Sensordaten werden geladen...'
    }
  },
  sensor: {
    error: {
      loading: 'Fehler beim Laden der Sensordetails',
      updating: 'Fehler beim Aktualisieren des Sensors',
      requiredFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
      title: 'Fehler',
      emptyFields: 'Die folgenden Felder sind erforderlich: {fields}',
      duplicateDevEui: 'Diese Sensor-ID existiert bereits im System',
      duplicateDevEuiHint: 'Die eingegebene Sensor-ID ist bereits einem anderen Sensor zugeordnet. Bitte geben Sie eine eindeutige ID ein.',
      creation: 'Fehler beim Erstellen des Sensors',
      creating: 'Fehler beim Erstellen des Sensors',
      checkingExistence: 'Fehler beim Überprüfen des Sensors',
    },
    add: {
      title: 'SENSOR-SCHNELLEINRICHTUNG: Bitte füllen Sie die folgenden Felder aus'
    },
    duplicate: {
      title: 'SENSORKONFIGURATION DUPLIZIEREN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      sensorId: 'Sensor-ID',
      dispenserName: 'Spendername',
      dispenserBrand: 'Spendermarke',
      dispenserArticleCode: 'Spender-Artikelcode',
      consumableBrand: 'Verbrauchsmaterialmarke',
      consumableArticleCode: 'Verbrauchsmaterial-Artikelcode',
      client: 'Kunde',
      building: 'Gebäude',
      floor: 'Etage',
      area: 'Bereich',
      maxSheets: 'Max. Anzahl Blätter',
      maxValue: 'Maximalwert - Abstand leerer Spender (mm)',
      minValue: 'Minimalwert - Abstand voller Spender (mm)',
      buttonType: 'Button-Typ'
    },
    selectDispenser: 'Spender auswählen',
    notManagedYet: 'Noch nicht verwaltet',
    emptyHours: 'Leere Stunden',
    full: 'Voll',
    empty: 'Leer'
  },
  login: {
    title: 'Anmeldung',
    button: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    error: 'Falscher Benutzername oder Passwort!',
    close: 'Schließen',
    forgotPassword: 'Passwort vergessen',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordInstructions: 'Bitte geben Sie die E-Mail-Adresse ein, die bei der Registrierung verwendet wurde',
    email: 'E-Mail',
    resetRequested: 'Zurücksetzung angefordert für:',
    enterNewPassword: 'Geben Sie Ihr neues Passwort in die Felder unten ein (stellen Sie sicher, dass beide Passwörter identisch sind, um fortzufahren)',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    passwordsDontMatch: 'Die Passwörter stimmen nicht überein'
  },
  KEY001: 'Anmeldung',
  key006: 'Falscher Benutzername oder Passwort!',
  key007: 'Schließen',
  validation: {
    required: 'Dieses Feld ist erforderlich',
    duplicateDevEui: 'Diese Sensor-ID existiert bereits'
  },
  building: {
    add: {
      title: 'NEUES GEBÄUDE ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Gebäudename',
      address: 'Gebäudeadresse'
    },
    error: {
      creation: 'Fehler beim Erstellen des Gebäudes'
    }
  },
  floor: {
    add: {
      title: 'NEUE ETAGE ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Etagenname',
      building: 'Gebäude'
    },
    error: {
      creation: 'Fehler beim Erstellen der Etage'
    }
  },
  area: {
    add: {
      title: 'NEUEN BEREICH ERSTELLEN: Bitte füllen Sie die folgenden Felder aus'
    },
    fields: {
      name: 'Bereichsname',
      building: 'Gebäude',
      floor: 'Etage'
    },
    error: {
      creation: 'Fehler beim Erstellen des Bereichs'
    }
  },
  washroomFrequency: {
    selectSensor: 'Wählen Sie einen Toilettensensor aus, um fortzufahren',
    loading: 'Laden...',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    sensor: 'Sensor',
    back: 'ZURÜCK',
    ok: 'OK',
    quickFilters: 'Schnellfilter:',
    hours: '4 STUNDEN',
    day: '1 TAG',
    week: '1 WOCHE',
    twoWeeks: '2 WOCHEN',
    thirtyDays: '30 TAGE',
    selectDateRange: 'Datumsbereich auswählen',
    cancel: 'Abbrechen',
    trafficOverview: 'VERKEHRSÜBERSICHT',
    currentTraffic: 'AKTUELLER VERKEHR',
    name: 'Name:',
    sensorType: 'Sensortyp:',
    sensorTypes: {
      'People Counter': 'People Counter',
      'Occupancy (PIR)': 'Präsenz (PIR)',
      'Door Counter': 'Türsensor'
    },
    averageAlertsNo: 'Durchschn. Alarme:',
    averageDailyTraffic: 'Durchschn. Verkehr<br>(ausgewählter Zeitraum):',
    averageDailyAlertsPeriod: 'Durchschn. tägl. Alarme<br>(ausgewählter Zeitraum):',
    dailyTraffic: 'Tägliche Nutzung:',
    time: 'Zeit:',
    currentTrafficValue: 'Aktueller Verkehr',
    dataManager: 'DATENMANAGER',
    sensorName: 'Sensorname:',
    cleaningSchedule: 'REINIGUNGSPLAN',
    washroomUsageFrequency: 'TOILETTENNUTZUNGSHÄUFIGKEIT',
    usageWithAlerts: 'NUTZUNG MIT/OHNE ALARM AUF DER SEITE',
    lastCleaning: 'Letzte Reinigung:',
    cleaningStatus: 'Reinigungsstatus:',
    alertThreshold: 'Alarmschwelle:',
    events: 'Ereignisse',
    cleaningRequired: 'Reinigung erforderlich',
    mightNeedClean: 'Könnte Reinigung benötigen',
    doesntNeedClean: 'Benötigt keine Reinigung',
    usageByDaytime: 'NUTZUNG NACH TAGESZEIT',
    morning: 'Morgen (00:00 - 12:00)',
    afternoon: 'Nachmittag (12:00 - 24:00)',
    usageByFourHourly: 'NUTZUNG NACH 4-STUNDEN-ZEITRÄUMEN',
    z1: 'Z1 (00–04)',
    z2: 'Z2 (04–08)',
    z3: 'Z3 (08–12)',
    z4: 'Z4 (12–16)',
    z5: 'Z5 (16–20)',
    z6: 'Z6 (20–24)',
    trafficVolumeVsAlert: 'BESUCHERAUFKOMMEN VS. ALARMSTATUS',
    normalTraffic: 'Normaler Betrieb',
    trafficDuringAlert: 'Betrieb bei aktivem Alarm',
    eventToAlert: 'Bis zur Warnung',
    eventTriggered: 'Registrierter Verkehr',
    serviceEfficiencyTimeline: 'EFFIZIENZ DER REINIGUNGSEINSÄTZE',
    responseTime: 'Reaktionszeit',
    cleaned: 'Gereinigt',
    alert: 'Alarm',
    sensorOverview: 'Sensorübersicht',
    online: 'Online',
    offline: 'Offline',
    lastDataReceivedLabel: 'Letzte Datenübertragung',
    lastCleaningLabel: 'Letzte Reinigung',
    alertThresholdLabel: 'Alarmschwelle',
    currentTrafficTitle: 'Aktueller Verkehr',
    aboveThreshold: 'Über der Schwelle',
    belowThreshold: 'Unter der Schwelle',
    live: 'Live',
    trafficLegend: 'Verkehr',
    thresholdLegend: 'Schwelle',
    remainingRange: 'Verbleibender Bereich',
    thresholdLabel: 'Schwelle',
    entriesUnit: 'Eintritte',
    avgDailyTrafficKpi: 'Durchschnittlicher Tagesverkehr',
    averageEntriesPerDay: 'Durchschnittliche Eintritte pro Tag',
    peakTrafficWindow: 'Spitzenzeitfenster',
    avgDailyCleaningActivities: 'Durchschnittliche tägliche Reinigungsaktivitäten',
    validatedOperationsPerDay: 'Validierte Vorgänge pro Tag',
    avgTrafficPerCleaning: 'Durchschnittlicher Verkehr pro Reinigung',
    entriesPerCleaning: 'Eintritte pro Reinigung',
    avgDailyAlertsKpi: 'Durchschnittliche tägliche Alarme',
    thresholdExceedancesPerDay: 'Schwellenüberschreitungen pro Tag',
    avgActiveHoursPerDay: 'Durchschnittliche aktive Stunden / Tag',
    hoursWithRecordedTraffic: 'Stunden mit erfasstem Verkehr'
  },
  manageSensors: {
    title: 'Sensoren verwalten',
    addNewSensor: 'Neuen Sensor hinzufügen',
    sensorDeleting: 'Sensor wird gelöscht',
    deleteConfirm: 'Sind Sie sicher, dass Sie "{name}" löschen möchten?',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    sensor: 'Sensor',
    clearFilter: 'Filter löschen',
    filter: 'Filter',
    type: 'Typ',
    fillLevel: 'Füllstand',
    liveUsage: 'Aktuelle Nutzung',
    cleaningLimit: 'Reinigungsschwelle',
    name: 'Name',
    company: 'Unternehmen',
    battery: 'Batterie',
    sensorId: 'Sensor-ID',
    actions: 'Aktionen',
    tooltips: {
      edit: 'Sensor bearbeiten',
      duplicate: 'Sensor duplizieren',
      delete: 'Sensor löschen'
    },
    buttonSubtypes: {
      feedback: 'Feedback',
      click: 'Service',
      RFID: 'RFID Validierung',
      display: 'Panel',
      RFID_BUTTON: 'RFID Button'
    },
    dispenserSubtypes: {
      foldedHandTowels: 'Falthandtücher',
      handTowelRolls: 'Handtuchrollen',
      foldedToiletPaper: 'Gefaltetes Toilettenpapier',
      toiletPaperRolls: 'Toilettenpapierrollen',
      soap: 'Seife'
    },
    editSensor: 'SENSOR BEARBEITEN',
    update: 'Aktualisieren',
    noDataAvailable: 'Keine Daten verfügbar'
  },
  alerts: {
    title: 'Alarme',
    alertTime: 'ALARMZEIT',
    solvedTime: 'GELÖST ZEIT',
    message: 'NACHRICHT',
    markAsDone: 'Als erledigt markieren',
    triggerAt: 'Ausgelöst am',
    resolvedAt: 'Gelöst am',
    duration: 'Dauer',
    confirmResolve: 'Alarmauflösung bestätigen',
    confirmResolveMessage: 'Möchten Sie diesen Alarm wirklich als {status} markieren?',
    resolved: 'gelöst',
    unresolved: 'ungelöst',
    sensorDetails: 'Sensordetails',
    sensorName: 'Sensorname',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    triggeredAt: 'Ausgelöst am',
    receivedAt: 'Empfangen am',
    status: 'Status',
    currentStatus: 'Aktueller Status',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    action: 'Aktion'
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Übersicht',
    statistics: 'Statistiken',
    editWidget: 'Widget bearbeiten',
    addWidget: 'Widget hinzufügen',
    widgetSize: 'Widget-Größe',
    size: 'Größe',
    small: 'Klein',
    medium: 'Mittel',
    large: 'Groß',
    sizes: {
      small: 'Klein',
      smallDesc: '1/4 Breite - Kompakte Widgets',
      medium: 'Mittel',
      mediumDesc: '1/2 Breite - Standard-Widgets',
      large: 'Groß',
      largeDesc: 'Volle Breite - Große Widgets'
    },
    addNewWidget: 'Neues Widget hinzufügen',
    kpiWidget: 'KPI-Widget',
    configureKpiWidget: 'KPI-Widget konfigurieren',
    widgetTitle: 'Widget-Titel',
    dataLevel: 'Datenebene',
    selectClient: 'Kunde auswählen',
    selectClients: 'Kunden auswählen',
    selectBuilding: 'Gebäude auswählen',
    selectBuildings: 'Gebäude auswählen',
    selectFloor: 'Etage auswählen',
    selectFloors: 'Etagen auswählen',
    selectArea: 'Bereich auswählen',
    selectAreas: 'Bereiche auswählen',
    selectSensor: 'Sensor auswählen',
    selectSensors: 'Sensoren auswählen',
    selectEntity: 'Entität auswählen',
    selectPeriod: 'Zeitraum auswählen',
    customPeriod: 'Benutzerdefinierter Zeitraum',
    selectDateRange: 'Datumsbereich auswählen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    sensor: 'Sensor',
    entitiesToCompare: 'Zu vergleichende Entitäten',
    kpiTypes: {
      restroomDailyUsage: {
        title: 'Tägliche Bereichsnutzung',
        description: 'Die durchschnittliche Anzahl täglicher Zutritte pro überwachten Bereich im ausgewählten Zeitraum.'
      },
      usageFrequencyComparison: {
        title: 'Nutzungsfrequenz – Vergleich',
        description: 'Vergleicht die Nutzung der ausgewählten Bereiche, um Spitzenzeiten zu erkennen.'
      },
      dispenserFillHeatmap: {
        title: 'Heatmap zum Füllstand der Spender',
        description: 'Zeigt den durchschnittlichen Füllstand der Spender über die täglichen Zeitfenster für den ausgewählten Bereich.',
        tableTitle: 'Heatmap zum Füllstand der Spender',
        tableSubtitle: 'Durchschnittlicher prozentualer Füllstand im ausgewählten Zeitraum.',
        colLocation: 'Spender & Bereichsstandort'
      },
      dispenserConsumptionAnalysis: {
        title: 'Verbrauch nach Spendermodell',
        description: 'Vergleicht den Verbrauch von Verbrauchsmaterialien nach Spender, Standort und Besuchen im ausgewählten Zeitraum.'
      }
    },
    dispenserConsumptionAnalysis: {
      tableTitle: 'Verbrauchsmaterialanalyse nach Spender',
      tableSubtitle: 'Vergleicht den Verbrauch von Verbrauchsmaterialien nach Spender, Standort und Besuchen im ausgewählten Zeitraum.',
      unitRolls: 'EINHEIT: ROLLEN',
      unitLiters: 'EINHEIT: LITER',
      unitSheets: 'EINHEIT: BLÄTTER',
      groupHandTowelRoll: 'Papierhandtuchrollen',
      groupFoldedTowels: 'Falthandtücher',
      groupToiletPaperRolls: 'Toilettenpapierrollen',
      groupFoldedToiletPaper: 'Toilettenpapier gefaltet',
      groupSoap: 'Seife',
      groupTotal: 'GRUPPENGESAMT',
      colDispenser: 'SPENDER',
      colLocation: 'STANDORT',
      colTotalConsumption: 'GESAMTVERBRAUCH',
      colAvgPerDay: 'DURCHSCHN. / TAG',
      colConsPer100Visits: 'VERBR. / 100 BESUCHE'
    },
    periodOptions: {
      lastDay: 'Letzter Tag',
      last7Days: 'Letzte 7 Tage',
      last14Days: 'Letzte 14 Tage',
      last30Days: 'Letzte 30 Tage',
      customPeriod: 'Benutzerdefinierter Zeitraum'
    },
    validation: {
      startDateRequired: 'Startdatum ist erforderlich',
      endDateRequired: 'Enddatum ist erforderlich',
      endDateAfterStart: 'Enddatum muss nach Startdatum liegen',
      futureDateNotAllowed: 'Enddatum darf nicht in der Zukunft liegen. Bitte wählen Sie bis gestern aus.',
      startDateTooOld: 'Startdatum darf nicht mehr als 30 Tage zurückliegen. Bitte wählen Sie ein aktuelleres Datum.',
      endDateBeforeStart: 'Enddatum muss nach Startdatum liegen.',
      periodTooShort: 'Zeitraum muss mindestens 1 Tag betragen.',
      periodTooLong: 'Ausgewählter Zeitraum ({days} Tage). Erwägen Sie kürzere Zeiträume für optimale Leistung.',
      validPeriod: 'Gültiger Zeitraum ausgewählt ({days} Tage).'
    },
    periodInfo: {
      period: 'Zeitraum',
      upTo: 'Bis',
      dataFrom: 'Daten von',
      lastDay: 'Daten von gestern ({date}) - Bis {date}',
      last7Days: 'Daten der letzten 7 Tage - Bis {date}',
      last14Days: 'Daten der letzten 14 Tage - Bis {date}',
      last30Days: 'Daten der letzten 30 Tage - Bis {date}',
      customRange: 'Benutzerdefinierter Zeitraum: {start} bis {end} - Bis {end}',
      selectCustomRange: 'Benutzerdefinierten Datumsbereich auswählen - Bis {date}'
    },
    tableHeaders: {
      article: 'Artikel',
      device: 'Gerät',
      location: 'Standort',
      packsUsed: 'Verwendete Packungen',
      refillsPerDay: 'Nachfüllungen / Tag',
      restroom: 'Toilette',
      avgEntriesPerDay: 'Durchschn. Eintritte / Tag',
      status: 'Status',
      avgAlertsPerDay: 'Durchschn. Alarme / Tag',
      trendVsPrevious: '▲ vs vorherigem Zeitraum',
      trendVsLastWeek: 'Trend vs vorherigem Zeitraum',
      deltaVsPrevious: 'Δ vs vorh.',
      client: 'Kunde',
      building: 'Gebäude',
      floor: 'Etage',
      area: 'Bereich',
      dispenser: 'Spender',
      item: 'Element',
      value: 'Wert'
    },
    status: {
      low: 'Niedrig',
      empty: 'Leer',
      normal: 'Normal',
      active: 'Aktiv'
    },
    summary: {
      clientsSelected: '{count} Kunden ausgewählt',
      buildingsSelected: '{count} Gebäude - {floors} Etagen - {sensors} Spender ausgewählt',
      floorsSelected: '{building} - {count} Etagen ausgewählt',
      clients: '{count} Kunden',
      buildings: '{count} Gebäude',
      floors: '{count} Etagen',
      areas: '{count} Bereiche',
      sensors: '{count} Sensoren',
      selected: 'ausgewählt'
    },
    selectAll: 'Alle auswählen',
    restroomUsageSensorLevelOnly: 'Dieser KPI erfordert eine Auswahl auf Sensorebene. Navigieren Sie durch Kunde > Gebäude > Etage > Bereich, um bestimmte Sensoren auszuwählen.'
  },
  alertsManagement: {
    pageTitle: 'Alarmverwaltung',
    addNewAlert: 'Neuen Alarm hinzufügen',
    createRule: 'Neue Regel erstellen',
    fillFields: 'Bitte füllen Sie die folgenden Felder aus',
    title: 'Titel',
    alertName: 'ALARMNAME',
    email: 'E-Mail (verwenden Sie ; zum Trennen von E-Mails)',
    emailLabel: 'E-Mail (verwenden Sie ; zum Trennen von E-Mails)',
    customMessage: 'Fügen Sie hier Ihre benutzerdefinierte Nachricht ein:',
    alertValue: 'Alarmwert (%) - Anzahl der Ereignisse',
    saveRule: 'Regel speichern',
    sensor: 'SENSOR',
    emailAddresses: 'E-MAIL-ADRESSEN',
    recipients: 'EMPFÄNGER',
    active: 'AKTIV',
    status: 'STATUS',
    phoneNumbers: 'TELEFONNUMMERN',
    airField: 'Zu überwachendes Feld',
    comparisonOperator: 'Vergleichsoperator',
    airFields: {
      pressure: 'Druck',
      co2: 'CO2',
      temperature: 'Temperatur',
      humidity: 'Feuchtigkeit'
    },
    buttonField: 'Drucktyp',
    buttonFields: {
      short: 'Kurz',
      long: 'Lang',
      double: 'Doppelt'
    },
    operators: {
      greaterThan: 'Größer als (>)',
      lessThan: 'Kleiner als (<)'
    },
    deleteConfirm: {
      title: 'Löschung bestätigen',
      message: 'Sind Sie sicher, dass Sie die Regel "{title}" löschen möchten?',
      description: 'Diese Aktion kann nicht rückgängig gemacht werden.'
    }
  },
  users: {
    title: 'Benutzer',
    manageUser: 'Benutzer verwalten',
    username: 'BENUTZERNAME',
    role: 'ROLLE',
    active: 'AKTIV',
    changePassword: 'Passwort ändern',
    changePasswordTitle: 'Füllen Sie die folgenden Felder aus, um Ihr Passwort zu ändern',
    oldPassword: 'Altes Passwort',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    passwordMinLength: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordChangedSuccess: 'Passwort erfolgreich geändert',
    passwordChangeError: 'Beim Speichern Ihres neuen Passworts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie das Support-Team.'
  },
  buildings: {
    title: 'Gebäude',
    name: 'Name',
    address: 'Adresse',
    sensors: 'Sensoren'
  },
  smartDispenser: {
    selectSensor: 'Wählen Sie einen Smart-Spender aus, um fortzufahren',
    loading: 'Laden...',
    quickFilters: 'Schnellfilter:',
    hours: '4 STUNDEN',
    day: '1 TAG',
    threeDays: '3 TAGE',
    week: '1 WOCHE',
    twoWeeks: '2 WOCHEN',
    lastMonth: 'LETZTER MONAT',
    selectDateRange: 'Datumsbereich auswählen',
    dataManager: 'DATENMANAGER',
    sensorName: 'Sensorname:',
    lastRefill: 'Letzte Nachfüllung:',
    consumption: 'Verbrauch:',
    binLevel: 'BEHÄLTERFÜLLSTAND',
    dispenserLevel: 'SPENDERFÜLLSTAND',
    dispenserAvailability: 'SPENDERVERFÜGBARKEIT – % VOLL vs LEER',
    dispenserDowntime: 'SPENDER-AUSFALLZEIT – LEERE STUNDEN / TAG',
    consumptions: 'VERBRAUCH',
    units: {
      sheets: 'Blätter',
      milliliters: 'Milliliter',
      rolls: 'Rollen'
    },
    downloadChartData: 'Diagrammdaten herunterladen',
    downloadAllData: 'Alle Sensordaten herunterladen',
    refillSchedule: 'NACHFÜLLPLAN',
    levelStatus: 'Füllstandstatus:',
    time: 'Zeit:',
    status: {
      offline: 'Offline - Heute keine Daten empfangen',
      needsRefill: 'Leer - Nachfüllung erforderlich',
      lowLevel: 'Niedriger Füllstand - Nachfüllung bald erforderlich',
      full: 'OK - Spender voll'
    },
    dispenserOverview: 'Spenderübersicht',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Letzte Datenübertragung',
    refillThreshold: 'Nachfüllschwelle',
    currentLevel: 'Aktueller Füllstand',
    currentCapacity: 'Aktuelle Kapazität',
    belowRefillThreshold: 'Unter der Nachfüllschwelle',
    aboveRefillThreshold: 'Über der Nachfüllschwelle',
    live: 'Live',
    availableLevel: 'Verfügbarer Füllstand',
    threshold: 'Schwelle',
    remainingCapacity: 'Verbleibende Kapazität',
    dispenserType: 'Spendertyp',
    avgDailyConsumption: 'Durchschnittlicher Tagesverbrauch',
    sheetsUsedPerDay: 'Blätter pro Tag',
    rollsUsedPerDay: 'Rollen pro Tag',
    mlUsedPerDay: 'ml pro Tag',
    avgDailyFillLevel: 'Durchschnittlicher täglicher Füllstand',
    averageDispenserLevel: 'Durchschnittlicher Spenderfüllstand',
    avgRefillInterval: 'Durchschnittliches Nachfüllintervall',
    daysBetweenRefills: 'Tage zwischen Nachfüllungen',
    avgDailyEmptyHours: 'Durchschnittliche tägliche Leerstandszeit',
    downtimePerDay: 'Ausfallzeit pro Tag',
    avgDailyAvailability: 'Durchschnittliche tägliche Verfügbarkeit',
    timeAboveEmptyLevel: 'Zeit über dem Leerstandsniveau',
    avgLevelAtRefill: 'Durchschnittlicher Füllstand bei Nachfüllung',
    levelWhenRefillHappens: 'Füllstand zum Zeitpunkt der Nachfüllung',
    includeWeekends: 'Wochenenden einschließen',
    selectedPeriod: 'Ausgewählter Zeitraum',
    clearFilter: 'Filter löschen',
    notAvailable: 'N/V'
  },
  smartBin: {
    selectSensor: 'Wählen Sie einen Smart-Behälter aus, um fortzufahren',
    binLevel: 'BEHÄLTERFÜLLSTAND',
    binFillLevel: 'BEHÄLTERFÜLLSTAND – NIVEAU',
    averageFillingLevel: 'DURCHSCHNITTLICHER FÜLLSTAND',
    fillLevel: 'Füllstand'
  },
  airQuality: {
    selectSensor: 'Wählen Sie einen Luftqualitätssensor aus, um fortzufahren',
    co2Level: 'CO2-NIVEAU',
    temperature: 'TEMPERATUR',
    humidity: 'LUFTFEUCHTIGKEIT',
    averageCo2: 'DURCHSCHNITTLICHES CO2-NIVEAU'
  },
  sensorDetails: {
    sensorDetails: 'Sensordetails',
    deviceInfo: 'Geräteinformationen',
    location: 'Standort',
    status: 'Status',
    lastUpdate: 'Letzte Aktualisierung'
  },
  cleaningLog: {
    title: 'Reinigungsprotokoll',
    time: 'Reinigung um',
    date: 'Datum',
    location: 'Standort',
    operator: 'Mitarbeiter',
    trigger: 'Trigger',
    responseTime: 'Reaktionszeit auf Alert',
    trafficHandled: 'Besucher seit letzter Reinigung',
    searchOperator: 'Mitarbeiter suchen',
    searchOperatorPlaceholder: 'Name oder Badge-ID...',
    noDataAvailable: 'Keine Reinigungsmaßnahmen verfügbar',
    alert: 'Alarm',
    routine: 'Routine',
    download: 'Herunterladen',
    downloadTooltip: 'Excel herunterladen',
    quickFilters: 'Schnellfilter:',
    timeSinceLastCleaning: 'Seit letzter Reinigung',
    selectDateRange: 'Datumsbereich auswählen',
    today: 'Heute',
    last7Days: '7 Tage',
    last14Days: '14 Tage',
    last30Days: '30 Tage',
    allPeriod: 'Alle',
    sensorOverview: 'Sensorübersicht',
    totalCleanings: 'Reinigungen gesamt',
    lastCleaning: 'Letzte Reinigung',
    avgTraffic: 'Ø Verkehr',
    periodSummary: 'Periodenübersicht',
    alertTriggered: 'Alarm-Auslösungen',
    routineTriggered: 'Routine',
    totalTraffic: 'Gesamtverkehr',
    avgResponseTime: 'Ø Reaktionszeit Alert'
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    ok: 'OK',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    continue: 'Fortfahren',
    search: 'Suchen',
    loading: 'Laden...',
    noDataAvailable: 'Keine Daten verfügbar',
    noDevicesConnected: 'Noch keine Geräte verbunden',
    yes: 'Ja',
    no: 'Nein',
    saveChanges: 'Änderungen speichern',
    itemsPerPage: 'Elemente pro Seite',
    all: 'Alle',
    of: 'von',
    days: {
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag'
    }
  },

  cleaningEfficiency: {
    title: 'Bereichsreinigungseffizienz',
    loading: 'Laden...',
    client: 'Kunde',
    building: 'Gebäude',
    floor: 'Etage',
    area: 'Bereich',
    dateRange: 'Datumsbereich',
    includeWeekends: 'Wochenenden einschließen',
    clearFilter: 'Filter löschen',
    quickFilters: 'Schnellfilter:',
    last4Hours: '4 Stunden',
    lastDay: '1 Tag',
    lastWeek: '1 Woche',
    last2Weeks: '2 Wochen',
    last30Days: '30 Tage',
    deviceOverview: 'Geräteübersicht',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Letzte Datenübertragung',
    lastCleaning: 'Letzte Reinigung',
    managedSensors: 'Verwaltete Sensoren',
    cleaningType: 'Reinigungstyp',
    currentAreaStatus: 'Aktueller Bereichsstatus',
    areaRecentlyCleaned: 'Bereich kürzlich gereinigt',
    live: 'Live',
    entriesSinceLastCleaning: 'Eintritte seit letzter Reinigung',
    trafficSinceLastCleaning: 'Verkehr seit letzter Reinigung',
    remainingRange: 'Verbleibender Bereich',
    threshold: 'Schwelle',
    avgReactionTime: 'Durchschn. Reaktionszeit',
    avgDailyCleans: 'Durchschn. tägliche Reinigungen',
    avgDailyAlerts: 'Durchschn. tägliche Alarme',
    avgManagedTraffic: 'Durchschn. verwalteter Verkehr',
    avgDailyAreaEntries: 'Durchschn. tägliche Bereichseintritte',
    avgTimeBetweenCleanings: 'Durchschn. Zeit zwischen Reinigungen',
    reactionTimeDesc: 'Reaktionszeit von Alarm bis Reinigung',
    cleaningsPerDay: 'Reinigungen pro Tag',
    alertsPerDay: 'Schwellenüberschreitungen pro Tag',
    managedTrafficDesc: 'Durchschnittliche Eintritte pro Reinigung',
    managedEntries: 'Verwaltete Eintritte',
    areaSensors: 'Bereichssensoren',
    associatedSensors: 'zugeordnete Sensoren',
    entriesSinceLastCleaningLabel: 'Eintritte seit letzter Reinigung',
    type: 'Typ',
    name: 'Name',
    liveUsage: 'Live-Nutzung',
    cleaningThreshold: 'Reinigungsschwelle',
    avgDailyEntries: 'Durchschn. tägliche Eintritte',
    avgDailyEntriesDesc: 'Durchschnittliche tägliche Eintritte jedes Sensors im verwalteten Bereich.',
    dailyEfficiencyChart: 'Tägliche Effizienz & Verkehr',
    cumulativeTraffic: 'Kumulativer Verkehr',
    alert: 'Alarm',
    rfidClean: 'RFID-Reinigung',
    alertThreshold: 'Alarmschwelle',
    noDataAvailable: 'Keine Daten für den ausgewählten Zeitraum verfügbar.',
    selectAreaToLoad: 'Wählen Sie Kunde, Gebäude, Etage und Bereich, um Daten zu laden.',
  },
}
